export default __webpack_public_path__ + "static/media/23.6f794c01.png";